(ns nosco.richtext.util
  (:require
   ["prosemirror-model" :as prosemirror-model]
   ["react-dom" :as react-dom]
   ["react-dom/client" :as react-dom-client]))

(defn render-into-dom-node
  "Renders a React element into a DOMNode.
  Returns a function which can be called to unmount the React root and cleanup."
  [node el]
  ;; Use a separate container and a Portal to avoid nesting React roots in the DOM
  (let [container (.createElement js/document "div")
        root (react-dom-client/createRoot container)
        portal (react-dom/createPortal el node)]
    (.setAttribute container "id" (name (gensym "nosco-richtext-util-react-container")))
    (.. js/document -body (appendChild container))
    (.render root portal)
    (fn []
      ;; Use setTimeout so that the root is unmounted asynchronously. Prevents React complaining
      (js/setTimeout
       (fn []
         (.unmount root)
         (.remove container))))))

(defn load-image [url]
  (js/Promise.
   (fn [resolve reject]
     (let [img (js/Image.)]
       (.addEventListener img "load" (fn [] (resolve img)))
       (.addEventListener img "error" (fn [event] (reject event)))
       (set! (.-src img) url)))))

(defn get-image-dimensions [url]
  (-> (load-image url)
      (.then
       (fn [img]
         [(.-width img) (.-height img)]))))

(defn empty-paragraph? [^js node]
  (and (some? node)
       (= "paragraph" (.. node -type -name))
       (zero? (.. node -content -size))))

(defn maybe-insert-empty-paragraph!
  "Insert an empty paragraph at pos if it is not immediately followed by an empty paragraph."
  [^js view pos]
  (let [$pos (.. view -state -doc (resolve pos))]
    (when-not (empty-paragraph? (.-nodeAfter $pos))
      (let [node (.. view -state -schema -nodes -paragraph (create))
            tr (.. view -state -tr (insert pos node))]
        (.dispatch view tr)))))

(defn figure-insertion-fragment
  "Returns a `Fragment` wrapping `figure-node` (i.e. an image or video),
  ensuring adequate spacing around it."
  [view figure-node pos]
  (let [^js $pos (.. view -state -doc (resolve pos))]
    (cond-> (.. prosemirror-model/Fragment (from figure-node))
      ;; Prepend with empty paragraph if `pos` is at the beginning of
      ;; the document, or is preceded by a figure
      (or (nil? (.-nodeBefore $pos))
          (= "figure" (.. $pos -nodeBefore -type -name)))
      (.addToStart (.. view -state -schema -nodes -paragraph (create)))

      ;; Append with empty paragraph if `pos` is at the end of the
      ;; document, or is followed by a figure
      (or (nil? (.-nodeAfter $pos))
          (= "figure" (.. $pos -nodeAfter -type -name)))
      (.addToEnd (.. view -state -schema -nodes -paragraph (create))))))
